import { Link } from "react-router-dom";
import { MapPin, Sparkles, ArrowRight } from "lucide-react";
import { Button } from "@/components/ui/button";

const primaryRegions = [
  {
    name: "London & South East",
    detail: "Our largest region",
  },
  {
    name: "West Midlands",
    detail: "Birmingham, Coventry, Wolverhampton and surrounding areas",
  },
  {
    name: "South Coast & South West",
    detail: "Plymouth, Bristol and South Coast including government and probation service contracts",
  },
];


const CoverageSection = () => {
  return (
    <section className="bg-muted/30 py-16 lg:py-20" aria-labelledby="coverage-heading">
      <div className="container mx-auto px-6">
        <div className="max-w-3xl mx-auto text-center mb-12">
          <h2 id="coverage-heading" className="text-3xl md:text-4xl font-bold text-foreground mb-3">
            Nationwide Coverage
          </h2>
          <p className="text-muted-foreground text-lg">
            We currently operate across 37 locations nationwide, including London &amp; South East, West Midlands, South West, Wales and the Isle of Man, within managed service environments.
          </p>
        </div>

        {/* Primary regions */}
        <div className="max-w-6xl mx-auto mb-10">
          <h3 className="text-sm font-semibold uppercase tracking-wider text-muted-foreground mb-4 text-center">
            Primary regions
          </h3>
          <ul className="grid grid-cols-1 md:grid-cols-3 gap-4">
            {primaryRegions.map((region) => (
              <li
                key={region.name}
                className="rounded-lg border border-border bg-card p-6 shadow-card hover:shadow-elevated transition-shadow flex flex-col items-center text-center"
              >
                <div className="flex h-12 w-12 items-center justify-center rounded-lg bg-primary/10 text-primary mb-4">
                  <MapPin className="h-6 w-6" />
                </div>
                <h4 className="text-lg font-semibold text-card-foreground leading-tight mb-2">
                  {region.name}
                </h4>
                <p className="text-sm text-muted-foreground leading-relaxed">{region.detail}</p>
              </li>
            ))}
          </ul>
        </div>

        {/* Don't see your location callout */}
        <div className="max-w-3xl mx-auto">
          <div className="shimmer-card relative rounded-2xl border-2 border-primary/30 bg-gradient-to-br from-primary/10 via-card to-accent/10 p-8 md:p-10 shadow-elevated flex flex-col items-center text-center">
            <div className="flex h-12 w-12 items-center justify-center rounded-xl bg-primary text-primary-foreground shadow-md mb-4">
              <Sparkles className="h-6 w-6" />
            </div>
            <h3 className="text-2xl md:text-3xl font-bold text-foreground mb-3">
              Don't see your location?
            </h3>
            <p className="text-muted-foreground leading-relaxed mb-6 max-w-2xl">
              If you have a requirement somewhere we haven't listed, tell us. We'll assess it and come back to you within 24 hours.
            </p>
            <Button asChild size="lg" className="bg-primary hover:bg-primary/90 text-primary-foreground">
              <Link to="/contact">
                Tell us where you need cover <ArrowRight className="ml-1 h-4 w-4" />
              </Link>
            </Button>
          </div>
        </div>
      </div>
    </section>
  );
};

export default CoverageSection;
